<div class="c-page-emloyeeconfirm"> 
  <div class="container">
    <div class="row mobile--orange u-pt30 u-pb30" *ngIf="type">
      <div class="col-md-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a [routerLink]="['/']"> {{'AccessConfirmationPortal.home'| translate}} </a></li>
            <li class="breadcrumb-item active" aria-current="page">&nbsp;-<span> {{'AccessConfirmationPortal.location'| translate}} </span></li>
          </ol>
        </nav>
        <h2 class="o-title" *ngIf="type.id ===1">{{'AccessConfirmationPortal.labelEmployee'| translate}}</h2>
        <h2 class="o-title" *ngIf="type.id ===2">{{'AccessConfirmationPortal.labelContractor'| translate}}</h2>
        <h2 class="o-title" *ngIf="type.id ===3">{{'AccessConfirmationPortal.labelVisitors'| translate}}</h2>
        <h2 class="o-title" *ngIf="type.id ===4">{{'AccessConfirmationPortal.labelException'| translate}}</h2>
        <!-- <h3>Type= {{type}} </h3> -->
      </div>
    </div>
  </div>
  <section class="c-results">
    <div class="container u-pt40">
      <div class="row">
        <div class="col-md-10 col-md-offset-1" *ngIf="status">
          
          <h2 class="o-title o-title--medium o-title--center" *ngIf="status.name!='Terminated'">{{'AccessConfirmationPortal.title' | translate}}</h2>
          <h2 class="o-title o-title--medium o-title--center"*ngIf="status.name==='Terminated'">{{'AccessConfirmationPortal.titleTerminate' | translate}}     </h2>


          <div class="o-steps">
            <div class="row">
              
              <div class="col-md-12" *ngIf="status">

                <div class="row" *ngIf="!items.facilityApproverId  && !(status.id==12 || status.id==13 || type.id ==3)">
                  <div class="col-md-offset-1 col-xs-5 o-steps__step o-steps__step--approved">
                    <div class="o-steps__circle"><i class="icon icon-check"> </i></div>
                    <label >{{'AccessConfirmationPortal.step1' | translate}} </label>
                    <p>{{'AccessConfirmationPortal.step1Details' | translate}}</p>
                  </div>
                  <div class="col-xs-5 o-steps__step" *ngIf="status.name!='Terminated'">
                    <div class="o-steps__circle"><i class="icon icon-more"> </i></div>
                    <label>{{'AccessConfirmationPortal.step2' | translate}}</label>
                    <p>{{'AccessConfirmationPortal.step2Details' | translate}}</p>
                  </div>
                  
                  <div class="col-xs-5 o-steps__step o-steps__step--rejected" *ngIf="status.name==='Terminated'">
                    <div class="o-steps__circle"><i class="icon icon-close"> </i></div>
                    <label>{{'AccessConfirmationPortal.step2' | translate}}</label>
                    <p>{{'AccessConfirmationPortal.reqTerminated' | translate}} </p>
                  </div>
                </div>



                <div class="row" *ngIf="!items.facilityApproverId && (status.id==12 || status.id==13 || type.id ==3)">

                  <div class="col-md-offset-1 col-xs-2 o-steps__step o-steps__step--approved">
                    <div class="o-steps__circle"><i class="icon icon-check"> </i></div>
                    <label class="js-txt5">{{ 'AccessConfirmationPortal.step1' | translate}}</label>
                    <p class="js-txt6">{{'AccessConfirmationPortal.reqSubmit' | translate}} </p>
                  </div>
                <!-- 2nd circle  -->
                  <div class="col-xs-5 o-steps__step o-steps__step--rejected" *ngIf="status.id===13">
                    <div class="o-steps__circle"><i class="icon icon-close"> </i></div>
                    <label>{{'AccessConfirmationPortal.step2' | translate}}</label>
                    <p>{{'AccessConfirmationPortal.reqTerminated' | translate}} </p>
                </div>
                <div class="col-xs-5  o-steps__step o-steps__step--approved" *ngIf="status.id===1 ||status.id===2 || status.id===4 || status.id===11 || status.id===3">
                  <div class="o-steps__circle"><i class="icon icon-check"> </i></div>
                  <label>{{'AccessConfirmationPortal.step2' | translate}}</label>
                  <p>{{'AccessConfirmationPortal.visitorComplete' | translate}}  </p>
                </div>


                <div class="col-xs-5  o-steps__step" *ngIf="status.id===12">
                  <div class="o-steps__circle"><i class="icon icon-more"> </i></div>
                  <label>{{'AccessConfirmationPortal.step2' | translate}}</label>
                  <p> {{'AccessConfirmationPortal.statusPendingVisitorForms' | translate}}</p>
                </div>

                <!-- 3rd circle  -->
                <div class="col-xs-2 o-steps__step" *ngIf="status.id===12 || status.id===1">
                  <div class="o-steps__circle"><i class="icon icon-more"> </i></div>
                  <label class="js-txt5">{{'AccessConfirmationPortal.step3' | translate}}</label>
                  <p>{{'AccessConfirmationPortal.step2Details' | translate}}</p>
              </div>
                <div class="col-xs-2  o-steps__step o-steps__step--rejected" *ngIf="status.id===11 || status.id===13">
                  <div class="o-steps__circle"><i class="icon icon-close"> </i></div>
                  <label> {{'AccessConfirmationPortal.step3' | translate}}</label>
                  <p>{{'AccessConfirmationPortal.reqTerminated' | translate}}</p>
                </div>

                <div class="col-xs-2 o-steps__step o-steps__step--approved" *ngIf="status.id===2 ">
                  <div class="o-steps__circle"><i class="icon icon-check"> </i></div>
                  <label>{{'AccessConfirmationPortal.step3' | translate}}</label>
                  <p>{{'AccessConfirmationPortal.reqApproved' | translate}} </p>
              </div>

              <div class="col-xs-2  o-steps__step o-steps__step--rejected" *ngIf="status.id===3 ">
                  <div class="o-steps__circle"><i class="icon icon-close"> </i></div>
                  <label> {{'AccessConfirmationPortal.step3' | translate}}</label>
                  <p>{{'AccessConfirmationPortal.rejectedPropWork' | translate}}</p>
              </div>

                  
              <div class="col-xs-2  o-steps__step " *ngIf="status.id===4">
                <div class="o-steps__circle" style="background-color: coral;"><i class="icon icon-arrow" style=" transform: rotateY(180deg);"> </i></div>
                <label> {{'AccessConfirmationPortal.step3' | translate}}</label>
                <p> {{'AccessConfirmationPortal.reqDelegated' | translate}}</p>
            </div>




                  <!-- <div class="col-md-offset-1 col-xs-5 o-steps__step o-steps__step--approved">
                    <div class="o-steps__circle"><i class="icon icon-check"> </i></div>
                    <label >{{'AccessConfirmationPortal.step1' | translate}} visita</label>
                    <p>{{'AccessConfirmationPortal.step1Details' | translate}}</p>
                  </div>
                  <div class="col-xs-5 o-steps__step" *ngIf="status.name!='Terminated'">
                    <div class="o-steps__circle"><i class="icon icon-more"> </i></div>
                    <label>{{'AccessConfirmationPortal.step2' | translate}}</label>
                    <p>{{'AccessConfirmationPortal.step2Details' | translate}}</p>
                  </div>
                  
                  <div class="col-xs-5 o-steps__step o-steps__step--rejected" *ngIf="status.name==='Terminated'">
                    <div class="o-steps__circle"><i class="icon icon-close"> </i></div>
                    <label>{{'AccessConfirmationPortal.step2' | translate}}</label>
                    <p>{{'AccessConfirmationPortal.reqTerminated' | translate}} </p>
                  </div>-->
                </div> 

                
                
                <!-- <div  *ngIf="!items.facilityApproverId && status">

                  
                  <div class="col-md-offset-1 col-xs-2 o-steps__step o-steps__step--approved" *ngIf="status.id">
                      <div class="o-steps__circle"><i class="icon icon-check"> </i></div>
                      <label>{{ 'AccessConfirmationPortal.step1' | translate}}</label>
                      <p>{{'AccessConfirmationPortal.reqSubmit' | translate}}</p>
                  </div>

                  
                  <div class="col-xs-5 o-steps__step" *ngIf="status.id===1">
                      <div class="o-steps__circle"><i class="icon icon-more"> </i></div>
                      <label>{{'AccessConfirmationPortal.step2' | translate}}</label>
                      <p>{{'AccessConfirmationPortal.status-pending-text' | translate}} </p>
                  </div>

                  <div class="col-xs-5 o-steps__step o-steps__step--rejected" *ngIf="status.id===3">
                      <div class="o-steps__circle"><i class="icon icon-close"> </i></div>
                      <label>{{'AccessConfirmationPortal.step2' | translate}}</label>
                      <p>{{'AccessConfirmationPortal.status-reject-text' | translate}} </p>
                  </div>
                  <div class="col-xs-5 o-steps__step o-steps__step--rejected" *ngIf="status.id===11">
                      <div class="o-steps__circle"><i class="icon icon-close"> </i></div>
                      <label>{{'AccessConfirmationPortal.step2' | translate}}</label>
                      <p>{{'AccessConfirmationPortal.reqTerminated' | translate}} </p>
                  </div>

                  <div class="col-xs-5 o-steps__step o-steps__step--approved" *ngIf="status.id===2">
                      <div class="o-steps__circle"><i class="icon icon-check"> </i></div>
                      <label>{{'AccessConfirmationPortal.step2' | translate}}</label>
                      <p> {{'AccessConfirmationPortal.reqApproved' | translate}} </p>
                  </div>

                  <div class="col-xs-6 o-steps__step " *ngIf="status.id===4">
                      <div class="o-steps__circle" style="background-color: coral;">
                          <i class="icon icon-arrow" style=" transform: rotateY(180deg);"> </i>
                      </div>
                      <label>{{'AccessConfirmationPortal.step2' | translate}}</label>
                      <p> {{'AccessConfirmationPortal.reqDelegated' | translate}}</p>
                  </div>
                    </div> -->

                <div class="row" *ngIf="items.facilityApproverId && status">

                  <div class="col-md-offset-1 col-xs-2 o-steps__step o-steps__step--approved" *ngIf="status.id!=10 && status.id!=9">
                      <div class="o-steps__circle"><i class="icon icon-check"> </i></div>
                      <label class="js-txt5">{{ 'AccessConfirmationPortal.step1' | translate}}</label>
                      <p class="js-txt6">{{'AccessConfirmationPortal.reqSubmit' | translate}}</p>
                  </div>

                  <div class="col-md-offset-1 col-xs-2 o-steps__step o-steps__step--approved" *ngIf="status.id===10 || status.id===9">
                      <div class="o-steps__circle"><i class="icon icon-check"> </i></div>
                      <label class="js-txt5">{{ 'AccessConfirmationPortal.step1' | translate}}</label>
                      <p class="js-txt6">{{'AccessConfirmationPortal.reqSubmit' | translate}}</p>
                  </div>

                  <!-- 2° circle Facility -->
                  <div class="col-xs-5 o-steps__step o-steps__step--rejected" *ngIf="status.id===11">
                      <div class="o-steps__circle"><i class="icon icon-close"> </i></div>
                      <label>{{'AccessConfirmationPortal.step2' | translate}}</label>
                      <p>{{'AccessConfirmationPortal.reqTerminated' | translate}} </p>
                  </div>
                  <div class="col-xs-5  o-steps__step o-steps__step--approved" *ngIf="status.id===5 && items.facilityPriority">
                      <div class="o-steps__circle"><i class="icon icon-check"> </i></div>
                      <label>{{'AccessConfirmationPortal.step2' | translate}}</label>
                      <p>{{'AccessConfirmationPortal.approvedPropWork' | translate}}  </p>
                  </div>

                  <div class="col-xs-5  o-steps__step" *ngIf="status.id===5 && !items.facilityPriority">
                      <div class="o-steps__circle"><i class="icon icon-more"> </i></div>
                      <label>{{'AccessConfirmationPortal.step2' | translate}}</label>
                      <p> {{'AccessConfirmationPortal.pendingApprover' | translate}}</p>
                  </div>

                  <div class="col-xs-5  o-steps__step o-steps__step--approved" *ngIf="status.id===7 && items.facilityPriority">
                      <div class="o-steps__circle"><i class="icon icon-check"> </i></div>
                      <label>{{'AccessConfirmationPortal.step2' | translate}}</label>
                      <p> {{'AccessConfirmationPortal.approvedPropWork' | translate}} </p>
                  </div>
                  <div class="col-xs-5  o-steps__step o-steps__step--approved" *ngIf="status.id===6 && !items.facilityPriority">
                      <div class="o-steps__circle"><i class="icon icon-check"> </i></div>
                      <label>{{'AccessConfirmationPortal.step2' | translate}}</label>
                      <p> {{'AccessConfirmationPortal.approvedApprover' | translate}} </p>
                  </div>
                  <div class="col-xs-5  o-steps__step " *ngIf="status.id===6 && items.facilityPriority">
                      <div class="o-steps__circle"><i class="icon icon-more"> </i></div>
                      <label>{{'AccessConfirmationPortal.step2' | translate}}</label>
                      <p> {{'AccessConfirmationPortal.pendingPropWork' | translate}} </p>
                  </div>

                  <div class="col-xs-5  o-steps__step o-steps__step--approved" *ngIf="status.id===8 && !items.facilityPriority">
                      <div class="o-steps__circle"><i class="icon icon-check"> </i></div>
                      <label>{{'AccessConfirmationPortal.step2' | translate}}</label>
                      <p> {{'AccessConfirmationPortal.approvedApprover' | translate}} </p>
                  </div>
                  <div class="col-xs-5  o-steps__step o-steps__step--approved" *ngIf="status.id===8 && items.facilityPriority">
                      <div class="o-steps__circle"><i class="icon icon-check"> </i></div>
                      <label>{{'AccessConfirmationPortal.step2' | translate}}</label>
                      <p> {{'AccessConfirmationPortal.approvedApprover' | translate}} </p>
                  </div>

                  <div class="col-xs-5  o-steps__step o-steps__step--rejected" *ngIf="status.id===10 && items.facilityPriority">
                      <div class="o-steps__circle"><i class="icon icon-close"> </i></div>
                      <label>{{'AccessConfirmationPortal.step2' | translate}}</label>
                      <p> {{'AccessConfirmationPortal.rejectedPropWork' | translate}} </p>
                  </div>

                  <div class="col-xs-5  o-steps__step o-steps__step--rejected" *ngIf="status.id===9 && !items.facilityPriority">
                      <div class="o-steps__circle"><i class="icon icon-close"> </i></div>
                      <label>{{'AccessConfirmationPortal.step2' | translate}}</label>
                      <p> {{'AccessConfirmationPortal.rejectedApprover' | translate}} </p>
                  </div>

                  <div class="col-xs-5  o-steps__step o-steps__step--approved" *ngIf="status.id===10  && !items.facilityPriority">
                      <div class="o-steps__circle"><i class="icon icon-check"> </i></div>
                      <label> {{'AccessConfirmationPortal.step2' | translate}}</label>
                      <p>{{'AccessConfirmationPortal.approvedApprover' | translate}} </p>
                  </div>
                  <div class="col-xs-5  o-steps__step o-steps__step--approved" *ngIf="status.id===9 && items.facilityPriority">
                      <div class="o-steps__circle"><i class="icon icon-check"> </i></div>
                      <label>{{'AccessConfirmationPortal.step2' | translate}}</label>
                      <p>{{'AccessConfirmationPortal.rejectedPropWork' | translate}}</p>
                  </div>

                  <!-- 3° circle  Facility- -->
                  <div class="col-xs-2 o-steps__step" *ngIf="status.id===5 && items.facilityPriority">
                      <div class="o-steps__circle"><i class="icon icon-more"> </i></div>
                      <label class="js-txt5">{{'AccessConfirmationPortal.step3' | translate}}</label>
                      <p class="js-txt6"> {{'AccessConfirmationPortal.pendingApprover' | translate}} </p>
                  </div>

                  <div class="col-xs-2 o-steps__step" *ngIf="status.id===5 && !items.facilityPriority">
                      <div class="o-steps__circle"><i class="icon icon-more"> </i></div>
                      <label class="js-txt5">{{'AccessConfirmationPortal.step3' | translate}}</label>
                      <p class="js-txt6"> {{'AccessConfirmationPortal.pendingPropWork' | translate}}  </p>
                  </div>

                  <div class="col-xs-2 o-steps__step" *ngIf="status.id===6 && !items.facilityPriority">
                      <div class="o-steps__circle"><i class="icon icon-more"> </i></div>
                      <label class="js-txt5">{{'AccessConfirmationPortal.step3' | translate}}</label>
                      <p class="js-txt6">{{'AccessConfirmationPortal.pendingPropWork' | translate}} </p>
                  </div>

                  <div class="col-xs-2 o-steps__step" *ngIf="status.id===6 && items.facilityPriority">
                      <div class="o-steps__circle"><i class="icon icon-more"> </i></div>
                      <label class="js-txt5">{{'AccessConfirmationPortal.step3' | translate}}</label>
                      <p class="js-txt6">{{'AccessConfirmationPortal.pendingApprover' | translate}}</p>
                  </div>

                  <div class="col-xs-2 o-steps__step o-steps__step--approved" *ngIf="status.id===7 && items.facilityPriority">
                      <div class="o-steps__circle"><i class="icon icon-check"> </i></div>
                      <label>{{'AccessConfirmationPortal.step3' | translate}}</label>
                      <p>{{'AccessConfirmationPortal.approvedApprover' | translate}} </p>
                  </div>

                  <div class="col-xs-2 o-steps__step o-steps__step--approved" *ngIf="status.id===8 && !items.facilityPriority">
                      <div class="o-steps__circle"><i class="icon icon-check"> </i></div>
                      <label>{{'AccessConfirmationPortal.step3' | translate}}</label>
                      <p> {{'AccessConfirmationPortal.approvedPropWork' | translate}} </p>
                  </div>

                  <div class="col-xs-2 o-steps__step o-steps__step--approved" *ngIf="status.id===8 && items.facilityPriority">
                      <div class="o-steps__circle"><i class="icon icon-check"> </i></div>
                      <label>{{'AccessConfirmationPortal.step3' | translate}}</label>
                      <p>{{'AccessConfirmationPortal.approvedPropWork' | translate}} </p>
                  </div>

                  <div class="col-xs-2  o-steps__step o-steps__step--rejected" *ngIf="status.id===10 && !items.facilityPriority">
                      <div class="o-steps__circle"><i class="icon icon-close"> </i></div>
                      <label> {{'AccessConfirmationPortal.step3' | translate}}</label>
                      <p>{{'AccessConfirmationPortal.rejectedPropWork' | translate}}</p>
                  </div>
                  <div class="col-xs-2  o-steps__step o-steps__step--rejected " *ngIf="status.id===10 && items.facilityPriority">
                      <div class="o-steps__circle"><i class="icon icon-close"> </i></div>
                      <label> {{'AccessConfirmationPortal.step3' | translate}}</label>
                      <p> {{'AccessConfirmationPortal.siteApprover' | translate}}</p>
                  </div>
                  <div class="col-xs-2  o-steps__step o-steps__step--rejected" *ngIf="status.id===9 && items.facilityPriority">
                      <div class="o-steps__circle"><i class="icon icon-close"> </i></div>
                      <label>{{'AccessConfirmationPortal.step3' | translate}}</label>
                      <p>{{'AccessConfirmationPortal.rejectedApprover' | translate}}</p>
                  </div>
                  <div class="col-xs-2  o-steps__step o-steps__step--rejected" *ngIf="status.id===9 && !items.facilityPriority">
                      <div class="o-steps__circle"><i class="icon icon-close"> </i></div>
                      <label> {{'AccessConfirmationPortal.step3' | translate}}</label>
                      <p> {{'AccessConfirmationPortal.propWork' | translate}} Facilities</p>
                  </div>



                </div>
















                
              </div>
            </div>
          </div>
          <div>
            <div class="row">
              <div class="col-md-8 col-md-offset-2">
                <div class="u-pt40 u-pb30 u-mb40 center c-results__box">
                  <h3> <span>{{'AccessConfirmationPortal.requestNumber' | translate}}:  </span> {{idS}}</h3>
                  <p>{{'AccessConfirmationPortal.msgCopyEmail' | translate}}</p>
                </div>
              </div>
            </div>
          </div>
          <p class="o-text o-text--big center">{{'AccessConfirmationPortal.msgTrackReq' | translate}}</p>
          <div class="row u-pt20">
            <div class="col-md-6 col-md-offset-3"><a class="btn btn--full btn--primary" [routerLink]="['/access-list/records']">{{'AccessConfirmationPortal.btnSeeRequest' | translate}}</a></div>
          </div>
        </div>
      </div>
      <div class="row u-pt60">
        <div class="col-md-12">
          <div class="hr"></div>
        </div>
        <div class="col-md-10 col-md-offset-1">
          <div class="o-reminder">
            <label class="o-title o-title--medium">{{'AccessConfirmationPortal.msgFooter' | translate}}</label>
             <div class="row u-pb20 u-mb20"> <!-- <label style="padding-top: 15px;" ></label> -->
              <div class="col-md-12 elementDiv" style="text-indent: 0 !important;">
                  <span class="elementSpan" >{{'AccessConfirmationPortal.contactCEP' | translate}}</span>
              </div>
          </div>
            

          
          <mat-accordion> 
            <div class="c-accordeon__item" style="margin-top: 0; padding-top: 0;">
            <mat-expansion-panel *ngIf="site.selfInfoZone">
              <mat-expansion-panel-header style="padding-left: 10px; padding-right: 10px;" >
                <mat-panel-title>
                  <strong  class="js-txta1">{{'AccessConfirmationPortal.labelSite' | translate}} </strong> 
                </mat-panel-title>
                <mat-panel-description> {{site.siteName}} </mat-panel-description>
              </mat-expansion-panel-header>
                  
              <mat-accordion>
                      <mat-expansion-panel  >
                          <mat-expansion-panel-header style="padding-left: 10px; padding-right: 10px;">
                            <mat-panel-title> 
                              <strong  class="js-txta1">{{'AccessConfirmationPortal.labelZone' | translate}} </strong> 
                              </mat-panel-title>
                            <mat-panel-description>{{site.zoneName}}</mat-panel-description>
                          </mat-expansion-panel-header>
                          
                          <mat-accordion *ngIf="site.selfInfoZone?.messhallInformation">
                            <mat-expansion-panel  >
                                <mat-expansion-panel-header style="padding-left: 10px; padding-right: 10px;" >
                                  <mat-panel-title > 
                                    <strong>{{site.selfInfoZone?.messhallInformation[0].segment.name}}</strong><img style="width: 20px; height: 20px; margin-left: 5px;" src="../assets/img/mess-hall.png" alt="Mess Hall">
                                  </mat-panel-title>
                                </mat-expansion-panel-header>
                                <div *ngFor=" let messhallItem of site.selfInfoZone?.messhallInformation" >
                                  <p *ngIf="getlang()==='en'" class="js-txta1" style="text-align: left;">{{messhallItem.descriptionEng}}</p>
                                  <p *ngIf="getlang()==='es'" class="js-txta1" style="text-align: left;">{{messhallItem.descriptionEsp}}</p>
                                </div>
                            </mat-expansion-panel>
                        </mat-accordion>
                      
                      
                        <mat-accordion *ngIf="site.selfInfoZone?.transportationInformation">
                          <mat-expansion-panel  >
                          <mat-expansion-panel-header style="padding-left: 10px; padding-right: 10px;" >
                            <mat-panel-title > 
                              <strong>{{site.selfInfoZone?.transportationInformation[0].segment.name}}</strong><img style="width: 20px; height: 20px; margin-left: 5px;" src="../assets/img/transportation.png" alt="Transportation">
                            </mat-panel-title>
                          </mat-expansion-panel-header>
                          <div *ngFor=" let transportationItem of site.selfInfoZone?.transportationInformation;">
                            <p *ngIf="getlang()==='en'" class="js-txta1" style="text-align: left;">{{transportationItem.descriptionEng}}</p>
                            <p *ngIf="getlang()==='es'" class="js-txta1" style="text-align: left;">{{transportationItem.descriptionEsp}}</p>
                          </div>
                         
                          </mat-expansion-panel>
                        </mat-accordion>  
                        
                        <mat-accordion  *ngIf="site.selfInfoZone?.accomodationInformation">
                          <mat-expansion-panel >
                          <mat-expansion-panel-header style="padding-left: 10px; padding-right: 10px;" >
                            <mat-panel-title > 
                              <strong>{{site.selfInfoZone?.accomodationInformation[0].segment.name}}</strong><img style="width: 20px; height: 20px; margin-left: 5px;" src="../assets/img/accomodation.png" alt="Accomodation">
                            </mat-panel-title>
                          </mat-expansion-panel-header>
                          <div *ngFor=" let accomodationItem of site.selfInfoZone?.accomodationInformation">
                            <p *ngIf="getlang()==='en'" class="js-txta1" style="text-align: left;">{{accomodationItem.descriptionEng}}</p>
                            <p *ngIf="getlang()==='es'" class="js-txta1" style="text-align: left;">{{accomodationItem.descriptionEsp}}</p>
                          </div>
                          </mat-expansion-panel>
                        </mat-accordion>   

                          <mat-accordion >
                            <mat-expansion-panel > 
                                <mat-expansion-panel-header *ngIf="site.subZoneId!='0'" style="padding-left: 10px; padding-right: 10px;">
                                  <mat-panel-title > 
                                   <strong  class="js-txta1">{{'AccessConfirmationPortal.labelSubZone' | translate}} </strong> 
                                  </mat-panel-title>
                                  <mat-panel-description>{{site.subZoneName}}</mat-panel-description>
                                </mat-expansion-panel-header>
                                
                                <mat-accordion *ngIf="site.selfInfoSubzone?.messhallInformation && site.subZoneId != 0"> 
                                  <mat-expansion-panel  >
                                      <mat-expansion-panel-header style="padding-left: 10px; padding-right: 10px;" >
                                        <mat-panel-title > 
                                          <strong>{{site.selfInfoSubzone?.messhallInformation[0].segment.name}}</strong><img style="width: 20px; height: 20px; margin-left: 5px;" src="../assets/img/mess-hall.png" alt="Mess Hall">
                                        </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <div *ngFor=" let messhallItem of site.selfInfoSubzone.messhallInformation" >
                                      <p *ngIf="getlang()==='en'" class="js-txta1" style="text-align: left;">{{messhallItem.descriptionEng}}</p>
                                      <p *ngIf="getlang()==='es'" class="js-txta1" style="text-align: left;">{{messhallItem.descriptionEsp}}</p>
                                    </div>
                                    </mat-expansion-panel>
                              </mat-accordion>
                              
                              <mat-accordion *ngIf="site.selfInfoSubzone?.transportationInformation && site.subZoneId != 0"> 
                                <mat-expansion-panel >
                                <mat-expansion-panel-header style="padding-left: 10px; padding-right: 10px;" >
                                  <mat-panel-title > 
                                    <strong>{{site.selfInfoSubzone?.transportationInformation[0].segment.name}}</strong><img style="width: 20px; height: 20px; margin-left: 5px;" src="../assets/img/transportation.png" alt="Transportation">
                                  </mat-panel-title>
                                </mat-expansion-panel-header>
                                <div *ngFor=" let transportationItem of site.selfInfoSubzone?.transportationInformation">
                                  <p *ngIf="getlang()==='en'" class="js-txta1" style="text-align: left;">{{transportationItem.descriptionEng}}</p>
                                  <p *ngIf="getlang()==='es'" class="js-txta1" style="text-align: left;">{{transportationItem.descriptionEsp}}</p>
                                </div>
                                </mat-expansion-panel>
                              </mat-accordion>    
                              
                              <mat-accordion *ngIf="site.selfInfoSubzone.accomodationInformation && site.subZoneId != 0" > 
                                <mat-expansion-panel >
                                <mat-expansion-panel-header style="padding-left: 10px; padding-right: 10px;" >
                                  <mat-panel-title > 
                                    <strong>{{site.selfInfoSubzone.accomodationInformation[0].segment.name}}</strong><img style="width: 20px; height: 20px; margin-left: 5px;" src="../assets/img/accomodation.png" alt="Accomodation">
                                  </mat-panel-title>
                                </mat-expansion-panel-header>
                                <div *ngFor=" let accomodationItem of site.selfInfoSubzone.accomodationInformation">
                                  <p *ngIf="getlang()==='en'" class="js-txta1" style="text-align: left;">{{accomodationItem.descriptionEng}}</p>
                                  <p *ngIf="getlang()==='es'" class="js-txta1" style="text-align: left;">{{accomodationItem.descriptionEsp}}</p>
                                </div>
                                </mat-expansion-panel>
                              </mat-accordion>                                    
                             
                            </mat-expansion-panel>
                        </mat-accordion>
                      </mat-expansion-panel>
                  </mat-accordion>
              
            </mat-expansion-panel>
          </div>
          </mat-accordion>

            
            
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
